import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _get from "lodash/get";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { unsubscribe, signin, createTUCustomer, enrollTUCustomer, verifyCaptcha } from "../actions";

var setFlag = function setFlag(name, val) {
  return function (state) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, name, val));
  };
};

export default createReducer((_createReducer = {}, _defineProperty(_createReducer, unsubscribe.success, setFlag('unsubscribeSuccess', true)), _defineProperty(_createReducer, unsubscribe.fail, setFlag('unsubscribeSuccess', false)), _defineProperty(_createReducer, verifyCaptcha.fail, setFlag('verifyCaptchaFailed', true)), _defineProperty(_createReducer, signin.fail, function (state, payload) {
  var isBlocked = payload.isBlocked,
      signinAttemptsRemaining = payload.signinAttemptsRemaining;
  return _objectSpread(_objectSpread({}, state), {}, {
    isSigninBlocked: isBlocked,
    signinAttemptsRemaining: signinAttemptsRemaining
  });
}), _defineProperty(_createReducer, enrollTUCustomer.fail, setFlag('enrollFailed', true)), _defineProperty(_createReducer, createTUCustomer.fail, function (state, payload) {
  if (_get(payload, 'internal_message') === 'User has attempted authentication too many times') {
    return _objectSpread(_objectSpread({}, state), {}, {
      createTURateLimited: true
    });
  }

  return state;
}), _createReducer), {});